// Partial — admin/gamification routes (issue #229).
// Covers: /admin/gamification (roulette control, flags, spins, ledger).
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminGamificationPage = lazyWithRetry(
  () => import("./pages/AdminGamificationPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/gamification", Component: AdminGamificationPage },
    ],
  },
];

export default routes;
